module.exports = __webpack_public_path__ + "img/univ_1n4.473cc4ea.png";